
import Vue, { PropType } from 'vue';
import { Component, Prop } from 'vue-property-decorator';

import Icon from 'JS/components/Icon.vue';
import { getOfferIndicator, OfferDisplayType, OfferIndicator } from 'JS/helpers/promo-helpers';

@Component({
	name: 'PromoIconWrapper',
	components: {
		Icon,
	},
})
class PromoIconWrapper extends Vue {
	@Prop({ type: String as PropType<OfferDisplayType>, default: 'normal' })
	type: OfferDisplayType;

	@Prop({ type: Boolean })
	monochrome: boolean;

	get offerIndicator(): OfferIndicator {
		return getOfferIndicator(this.type);
	}

	get color(): string {
		return this.monochrome
			? '#656E97'
			: this.offerIndicator.color;
	}
}

export default PromoIconWrapper;
